import React, { Fragment } from 'react';
import {
  withLang,
  WithLangProps
} from '../../provider/LanguageProvider/withLang';

interface LocaleNumberProps {
  value: number;
  options?: Intl.NumberFormatOptions;
}

const LocaleNumber = ({
  value,
  options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  },
  lang
}: LocaleNumberProps & WithLangProps) => {
  return <Fragment>{value.toLocaleString(lang.locale, options)}</Fragment>;
};

export default withLang(LocaleNumber);
